import { useDraggable, useDroppable } from '@dnd-kit/core';
import { CatalogDragItemData } from './useCatalogProductsDragAndDrop.types';

interface UseCatalogDraggableItemParams {
  id: string;
  isDraggingDisabled: boolean;
  data: CatalogDragItemData;
}

export const useCatalogDraggableItem = ({
  id,
  isDraggingDisabled,
  data,
}: UseCatalogDraggableItemParams) => {
  const {
    attributes,
    listeners,
    setActivatorNodeRef,
    setNodeRef: setDraggableNodeRef,
  } = useDraggable({
    id,
    disabled: isDraggingDisabled,
    data,
  });

  const { setNodeRef: setDroppableNodeRef } = useDroppable({ id });

  const setNodeRef = (node: HTMLElement | null) => {
    setDraggableNodeRef(node);
    setDroppableNodeRef(node);
  };

  return { attributes, listeners, setActivatorNodeRef, setNodeRef };
};
